async function thirdPartyCookiesEnabled() {
    // TODO: Maybe can be enabled later to include other browsers?
    // if (typeof window?.ALMA?.tunnus?.cookiesEnabled === "function") {
    //   return window.ALMA.tunnus.cookiesEnabled();
    // }
    return !/.*Version.*Safari.*/.test(navigator.userAgent);
}
export default thirdPartyCookiesEnabled;
//# sourceMappingURL=cookie-check.js.map